import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

const Breadcrumbs = (props) => {
  const [modify, setModify] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setModify(location.pathname.includes('fields'));
  }, [location]);

  const determineCrumbs = (props) => {
    const { container, form, fieldset } = props;

    return (
      <>
        <li>
          <Link to='/manage'>Containers</Link>
        </li>
        {container && (
          <li>
            <Link to={`/manage/containers/${container.id}`}>
              {container.name}
            </Link>
          </li>
        )}
        {form && (
          <li>
            <Link to={`/manage/forms/${form.id}` + (modify ? '/edit' : '')}>
              {form.name + (modify ? ' (Edit)' : '')}
            </Link>
          </li>
        )}
        {fieldset && (
          <li>
            <Link to={`/manage/fieldsets/${fieldset.id}`}>{fieldset.name}</Link>
          </li>
        )}
      </>
    );
  };

  return (
    <>
      <header>
        <div className='breadcrumbs'>
          <ol>{determineCrumbs(props)}</ol>
        </div>
      </header>
    </>
  );
};

export default Breadcrumbs;
